<template>
    <v-layout justify-center wrap id="customer-create">
        <v-flex md6 xs6>
            <CreateCustomer />
        </v-flex>
    </v-layout>
</template>

<script>
import CreateCustomer from '@/components/customer/CreateCustomer.vue';

export default {
    name: 'customer-create',
    components: {
        CreateCustomer,
    },
};
</script>

<style scoped lang="scss">
</style>
